import { getMaxCharValidation } from '@tableau/widgets';

export function characterCounter(args: {value: string, maximum: number}): string {
  return getMaxCharValidation(args.value || '', args.maximum).message as string;
}
